import { Fragment, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./video-ai.css";
import axios from "axios";
import { UserAuthContext } from "../../Contexts/UserAuthContext";
import swal from "sweetalert";
import reload from "../../Assets/Images/relaoder.png";
import InfoIcon from "@mui/icons-material/Info";
import { IconButton } from "@material-ui/core";
import SampleVideoModal from "../../Components_V2/VideoAi/SampleVideoModal";
import SampleTextVideo from "../../Components_V2/AIVideoSample/TextVideo";
import Swal from "sweetalert2";
import CreditsButton_V2 from "../../Components_V2/CreditsButton/CreditsButton";
import PageHeading_V2 from "../../Components_V2/PageHeading/PageHeading";

const ComicVideo_V2 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [randomQuestion, setRandomQuestion] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [isDark, setIsDark] = useState(false);
  const [script, setScript] = useState({});

  const handleCheckboxChange = (event) => {
    setIsDark(event.target.checked);
  };

  const getRandomQuestion = () => {
    const questions = [
      "The Birth of the Solar System",
      "How Dinosaurs Ruled the Earth",
      "The Wonders of the Human Brain",
      "How the Internet Works",
      "The History of Space Exploration",
      "Understanding Climate Change",
      "The Mysteries of the Ocean",
      "How Planes Stay in the Air",
      "The Evolution of Life on Earth",
      "How Volcanoes Erupt",
      "The Science of Earthquakes",
      "The Life Cycle of a Star",
      "The Secrets of DNA",
      "The History of Ancient Egypt",
      "The Human Digestive System Explained",
      "How Batteries Store Energy",
      "The Journey of a Raindrop",
      "The Physics of Roller Coasters",
      "The World of Microbes",
      "The History of the Roman Empire",
      "The Function of the Human Heart",
      "The Science Behind Vaccines",
      "The Basics of Quantum Physics",
      "How Plants Perform Photosynthesis",
      "The History of the Olympic Games",
      "How Electricity Powers Our World",
      "The Science of Cooking",
      "The Story of the Great Wall of China",
      "How Computers Work",

      "The Wonders of the Animal Kingdom",
      "The History of the Renaissance",
      "How Telescopes Work",
      "The Life of a Honeybee",
      "The Basics of the Human Immune System",
      "The Science Behind Weather Forecasting",
      "The Story of the Titanic",
      "The Evolution of Human Languages",
      "How the Moon Affects Earth",
      "The History of the American Civil War",
      "The Life Cycle of a Butterfly",
      "The Science of Sound Waves",
      "The History of the Printing Press",
      "How Bridges Are Built",
      "The Secrets of Coral Reefs",
      "The History of the Space Race",
      "The Basics of Human Genetics",
      "The Science of Optical Illusions",
      "The History of the Internet",
      "How Engines Work",
      "The Wonders of the Night Sky",
      "The History of Ancient Greece",
      "The Human Respiratory System Explained",
      "The Science of Renewable Energy",
      "The Story of the Pyramids",
      "How Robots Work",
      "The Basics of Chemical Reactions",
      "The History of the French Revolution",
      "The Science Behind Time Travel Theories",
      "The World of Insects",
      "The Evolution of Technology",
      "How Submarines Work",
      "The History of Medieval Europe",
      "The Science of Sleep",
      "The Wonders of the Amazon Rainforest",
      "How Magnets Work",
      "The History of the Industrial Revolution",
      "The Science of Climate Zones",
      "The Evolution of the Human Species",
      "How Satellites Work",
      "The History of the Cold War",
      "The Human Circulatory System Explained",
      "The Science of Germs and Hygiene",
      "The History of Ancient Mesopotamia",
      "How Skyscrapers Are Built",
      "The Basics of Ecosystems",
      "The Story of the Wright Brothers",
      "How Solar Panels Work",
      "The Science of Black Holes",
      "The History of the Viking Age",
      "The Human Skeletal System Explained",
      "The Science of Natural Disasters",
      "The History of the Space Shuttle",
      "How Rockets Work",
      "The Wonders of the Desert Biome",
      "The Basics of Photosynthesis",
      "The History of the British Empire",
      "The Science Behind the Human Voice",
      "The Evolution of Music",
      "How Wind Turbines Work",
      "The History of the American Revolution",
      "The Human Nervous System Explained",
      "The Science of Bacteria",
      "The History of the World Wars",
      "How 3D Printing Works",
      "The Wonders of the Arctic Circle",
      "The Basics of Animal Behavior",
      "The Story of the Moon Landing",
      "The Science Behind Holograms",
      "The History of Ancient Rome",
      "How Electric Cars Work",
    ];

    const randomIndex = Math.floor(Math.random() * questions.length);
    return questions[randomIndex];
  };

  // Set random question when component mounts
  useEffect(() => {
    setRandomQuestion(getRandomQuestion());
  }, []);

  const [isGenerateButtonDisabled, setIsGenerateButtonDisabled] =
    useState(false);

  const { AIuser, userRefetch, setUserRefetch, isBack } =
    useContext(UserAuthContext);

  const [inputText, setInputText] = useState("");
  const [enableOwnScript, setEnableOwnScript] = useState(false);
  const [videoModal, setVideoModal] = useState(false);
  const [indexValue, setIndexValue] = useState(1);
  const [generatedText, setGeneratedText] = useState(
    "Artificial Intelligence (AI) is a rapidly growing field of technology that is revolutionizing the way we interact with the world. AI is the ability of a computer or machine to think and learn like a human. It is a form of intelligence that is based on algorithms and data, rather than on human intelligence.\n\n\nAI is used in a variety of applications, from self-driving cars to medical diagnosis. AI is used to automate tasks that would otherwise require human intelligence. For example, AI can be used to analyze large amounts of data and make decisions based on the data. AI can also be used to recognize patterns in data and make predictions about future events.\n\n\nAI can also be used to create virtual assistants that can respond to user queries and provide helpful information. AI is also being used to create robots that can interact with humans in a more natural way. These robots can be used to perform tasks such as cleaning, cooking, and providing companionship.\n\n\nAI is also being used to create virtual reality experiences that can be used for entertainment or educational purposes. AI is also being used to create autonomous vehicles that can drive themselves. These vehicles are being developed to reduce the number of accidents on the road and to make transportation more efficient.\n\n\nAI is also being used to create autonomous drones that can be used for surveillance or delivery purposes. AI is also being used to create intelligent machines that can understand natural language and respond to user queries. These machines can be used to provide customer service or to provide information about products and services.\n\n\nAI is also being used to create intelligent robots that can interact with humans in a more natural way. AI is a rapidly growing field of technology that is revolutionizing the way we interact with the world. AI is being used in a variety of applications, from self-driving cars to medical diagnosis. AI is also being used to create autonomous vehicles, robots, and intelligent machines that can understand natural language and respond to user queries. AI is a powerful tool that is being used to create a more efficient and safer world."
  );

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (location?.state?.back && isBack) {
      const backText = location?.state?.text;
      const backInput = location?.state?.inputText;
      setInputText(backInput);
      setGeneratedText(backText);
    }
    // const isBack = location?.state?.back;
  }, [location, isBack]);

  useEffect(() => {
    if (location.state !== null) {
      setInputText(location.state.requestQues);
      setGeneratedText(location.state.response);
    }
  }, [location.state]);

  function generateRandomAlphanumeric() {
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < 8; i++) {
      const randomIndex = Math.floor(Math.random() * chars.length);
      result += chars[randomIndex];
    }
    return result;
  }

  const handleSubmitCredits = async (e) => {
    const deductedCredits = AIuser.credits - 120;

    // console.log("question", question, conversation);
    await axios
      .put(
        "https://backend.whalesai.com/api/dashboard/user_signup-signin/update-credits",
        { email: AIuser?.email, credits: deductedCredits },
        {
          headers: {
            authorization: `Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9`,
          },
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setUserRefetch(!userRefetch);
        }
      })
      .catch((err) => {
      });
  };

  const ConfirmVideo = async () => {
    if (isGenerateButtonDisabled) return;

    if (AIuser.credits > 120) {
      // Show the popup after a short delay (1 second)
      setTimeout(() => {
        const wrapper = document.createElement("div");
        wrapper.innerHTML = `<p></p> <p class="text-white">we are generating the video for you. We will send the video links to <span class="text-warning">${AIuser?.email}</span>. It might take up to 10 mins. <br/> You can generate more contents while waiting for our email.</p> `;

        swal({
          content: wrapper,
          icon: "success",
          button: "Close",
          className: "modal_class_success",
        }).then(() => {
          // Update the button text to "Refreshing the page for you"
          swal({
            icon: "success",
            button: {
              text: "Refreshing the page for you",
              className: "bg-danger",
            },
            confirmButtonClass: "bg-danger",
            className: "modal_class_success",
            closeOnClickOutside: false, // Prevent closing by clicking outside
          });

          // Reload the page after a short delay to allow the user to see the updated text
          setTimeout(() => {
            window.location.reload();
          }, 1000); // Adjust the delay as needed
        });
      }, 1000);

      setGeneratedText("");
      setIsLoading(true);
      handleSubmitCredits();

      const bodyContent = {
        email: AIuser?.email,
        userId: AIuser?._id,
        isDark: isDark,
        transactionId: generateRandomAlphanumeric(),
      };
      console.log("Video Data =>", bodyContent);

      if (enableOwnScript) {
        bodyContent.description = inputText;
      } else {
        bodyContent.question = inputText;
      }

      try {
        const response = await fetch(
          `https://backend.whalesai.com/api/v1/img/generate-comic-video?dimension=all`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(bodyContent),
          }
        );

        if (!response.ok) {
          throw new Error("Failed to generate video");
        }

        const data = await response.json();
        if (data.message === "Video created successfully") {
          alert("video created successfully");

          setIsLoading(false);
        } else {
          throw new Error("Failed to generate video");
        }
      } catch (error) {
        console.error("Error generating video:", error);
        setIsLoading(false);
      }
    } else {
      swal({
        text: "You don't have enough credits! Please buy credits to continue.",

        icon: "error",
        buttons: "Buy",
        className: "modal_class_success",
      }).then((value) => {
        if (value) {
          navigate("/ver2/purchase");
        }
      });
    }
  };

  const DisableBtn = async () => {
    const wrapper = document.createElement("div");
    wrapper.innerHTML = `<p></p> <p class="text-danger">Warning: Your text exceeds 600 words. Please edit it to 600 words or let the AI generate a shortened version for you.</p> `;

    return swal({
      content: wrapper,
      icon: "error",
      buttons: "Ok",
      className: "modal_class_success",
    });
  };

  const handleTextChange = (e) => {
    const text = e.target.value;
    const wordCount = text.split(/\s+/).length;
    setInputText(text);
    setGeneratedText("");

    if (enableOwnScript && wordCount > 600) {
      setIsGenerateButtonDisabled(true);
    } else {
      setIsGenerateButtonDisabled(false);
    }
  };

  console.log(inputText.length);

  const handleTrigger = () => {
    setInputText("");
    setEnableOwnScript(false);
  };

  {
    /* Will Implement later: Start */
  }
  const [selectedOption, setSelectedOption] = useState("");
  // const [isDark, setIsDark] = useState(false);
  const [isGradient, setIsGradient] = useState(false);
  const [isRandomColor, setIsRandomColor] = useState(false);
  const [isBoth, setIsBoth] = useState(false);
  const [videoPosition, setVideoPosition] = useState(0);

  const handleCheckGradient = () => {
    setIsGradient(true);
    setIsRandomColor(false);
    setIsBoth(false);
    // setIsDark(false);
    setVideoPosition(3);
  };

  const handleCheckRandomColor = () => {
    setIsRandomColor(true);
    setIsBoth(false);
    // setIsDark(false);
    setIsGradient(false);
    setVideoPosition(4);
  };

  const handleCheckBothGR = () => {
    setIsBoth(true);
    // setIsDark(false);
    setIsGradient(false);
    setIsRandomColor(false);
    setVideoPosition(2);
  };

  const handleOptionChange = (e) => {
    const value = e?.target?.value;

    // console.log("vvvvvvvvvvvvv", value);
    setSelectedOption(value);

    switch (value) {
      case "Gradient":
        handleCheckGradient();
        break;
      case "Random Colors":
        handleCheckRandomColor();
        break;
      case "Random Color Gradients":
        handleCheckBothGR();
        break;
      case "Classic Black and White":
        handleCheckboxChange();
        break;
      default:
        setVideoPosition(0);
        break;
    }
  };

  {
    /* Will Implement later: End */
  }

  return (
    <Fragment>
      <PageHeading_V2
        title="Comic Video AI"
        description="The Comic Video AI is capable of creating narrated comic videos."
      />

      <SampleTextVideo
        videoModal={videoModal}
        setVideoModal={setVideoModal}
        indexValue={1}
      />
      <div className="img-ai-container container pb-5">
        <div
          style={{
            maxWidth: "872px",
            paddingInline: "12px",
            marginInline: "auto",
          }}
        >
          <div className="position-relative">
            {" "}
            {/* Adjust height as needed */}
            <IconButton
              style={{
                color: "#ffa21f",
                position: "absolute",
                top:
                  window.innerWidth < 576
                    ? "calc(0px - 70px)"
                    : "calc(0px - 100px)", // Moves 30px up from the top
                left: "50%", // Horizontal center
                transform: "translateX(-50%)", // Ensures it's centered from its width
              }}
              onClick={() => setVideoModal(true)}
              title="See sample video"
            >
              <InfoIcon />
            </IconButton>
          </div>
          <div className="d-flex align-items-center justify-content-center centralize-credits-btn-sm">
            <div className="d-flex ">
              <CreditsButton_V2 />
            </div>
          </div>
          <p
            style={{ fontSize: "8px" }}
            className="text-white text-center mt-2 mb-0 centralize-credits-btn-sm"
          >
            120 Credits per video
          </p>
        </div>

        <div className="container pt-3">
          <div style={{ maxWidth: "850px" }} className="mx-auto">
            <div className="d-flex align-items-center justify-content-center">
              <p className="text-white centralize-credits-btn-sm text-center">
                {`${enableOwnScript ? "Enter your own script (max 600 words)." : "Enter Title of Comic Video you want to generate."}`}
              </p>
            </div>
            {!enableOwnScript && (
              <div
                style={{ flexDirection: "column" }}
                className="d-flex align-items-center text-center text-sm-start"
              >
                <p
                  onClick={() => setInputText(randomQuestion)}
                  style={{ cursor: "pointer" }}
                  className="text-warning my-2 text-center"
                >
                  <span className="text-danger">Example:</span> {randomQuestion}
                </p>
                <img
                  onClick={() => setRandomQuestion(getRandomQuestion())}
                  style={{ cursor: "pointer" }}
                  src={reload}
                  alt="reload"
                  width="30"
                  height="30"
                  className="my-2"
                />
              </div>
            )}
            <div
              className="ai-send-text mt-2 position-relative"
              style={{ marginBottom: 10, paddingBottom: "23px" }}
            >
              <form>
                <div className="d-flex justify-content-between align-items-end">
                  <textarea
                    className={`bg-transparent border-0 w-100 text-white ask-ai-fonts ai-textarea ${!enableOwnScript && ""}`}
                    type="text"
                    lang="en"
                    placeholder=""
                    value={inputText}
                    id="inputText"
                    name="inputBox"
                    rows={enableOwnScript ? 8 : 4}
                    onChange={handleTextChange}
                  />
                  <div
                    className="ai-sent-item d-flex justify-content-end align-items-end"
                    type="submit"
                    style={{ cursor: "pointer" }}
                  >
                  </div>
                </div>
              </form>
              {inputText && enableOwnScript && (
                <p
                  className={`mb-0 text-white me-auto ${inputText?.split(/\s+/).length == 600 && "text-danger"}`}
                  style={{
                    fontSize: "13px",
                    fontWeight: "500",
                    letterSpacing: "0.1px",
                    position: "absolute",
                    right: "17px",
                    bottom: "9px",
                  }}
                >
                  {inputText?.split(/\s+/).length}/600 words
                </p>
              )}
            </div>
            {inputText?.split(/\s+/).length > 600 && (
              <div
                style={{ cursor: "pointer" }}
                onClick={() => handleTrigger()}
                className="warning "
              >
                Warning: Your text exceeds 600 words. Please edit it to 600
                words or let the AI generate a shortened version for you.
              </div>
            )}

            {/* Will Implement later: Start */}

            <div
              className="d-flex align-items-center justify-content-center text-center mt-4"
              onClick={() => {
                Swal.fire({
                  title: "Coming Soon !",
                  // text: "This feature will be available soon!",
                  icon: "info",
                  confirmButtonText: "OK",
                  background: "#011225",
                });
              }}
              style={{ cursor: "pointer" }} // Add pointer cursor for clickable effect
            >
              <select
                className="form-select form-select-sm text-uppercase"
                value={selectedOption}
                onChange={handleOptionChange}
                style={{ width: "220px", pointerEvents: "none" }} // Prevent interaction with the select element
                disabled
              >
                <option value="">Please select</option>
                <option value="Gradient">Gradient</option>
                <option value="Random Colors">Colors</option>
                <option value="Random Color Gradients">Color Gradients</option>
                <option value="Classic Black and White">B & W</option>
              </select>
              {videoPosition == 0 ? (
                " "
              ) : (
                <IconButton
                  style={{ color: "#ffa21f" }}
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent the SweetAlert from triggering
                    setModalShow(true);
                  }}
                  title="See sample video"
                  className="mt-0"
                >
                  <InfoIcon />
                </IconButton>
              )}
            </div>

            {/* Will Implement later: End */}

            <div className="mt-4 text-center">
              <button
                onClick={() => {
                  setInputText("");
                  setGeneratedText("");
                  setIsGenerateButtonDisabled(false);
                }}
                className="clear-button rounded"
              >
                Clear
              </button>

              <button
                onClick={ConfirmVideo}
                className={`generate-button rounded ${!inputText ? "bg-secondary" : ""}`}
                disabled={!inputText || isLoading}
              >
                Generate
              </button>
            </div>
            <p className="mt-3"></p>
            <div
              style={{ fontSize: "8px" }}
              className="animate text-md-center mt-4 text-lg-center text-center d-flex justify-content-center force-small-font"
            >
              Please do not navigate away from the browser.
              <br /> Doing so will stop the process.
            </div>
            <div className="btnvideoDiv"></div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ComicVideo_V2;
